const cacheUpdaterAdd = ({ context }) => (cache, { data }) => {
    var _a;
    if (!data || !data[context.fieldName]) {
        return undefined;
    }
    const newEntity = data[context.fieldName].item;
    for (const { query, variables = {}, fieldName } of (_a = context.queries) !== null && _a !== void 0 ? _a : []) {
        // Read query from cache
        const data = cache.readQuery({
            query,
            variables,
        });
        if (!data)
            continue;
        // Add newly created item to the cache copy
        const result = Object.assign({}, data, {
            [fieldName]: Object.assign(Object.assign({}, data[fieldName]), { items: [
                    newEntity,
                    ...data[fieldName].items.filter((item) => item.id !== newEntity.id),
                ] }),
        });
        //Overwrite the cache with the new results
        cache.writeQuery({
            query,
            data: result,
            variables,
        });
    }
};
const cacheUpdaterRemove = ({ context }) => (cache) => {
    var _a;
    const deletedId = context.variables.id ||
        (context.variables.input && context.variables.input.id);
    for (const { query, variables, fieldName } of (_a = context.queries) !== null && _a !== void 0 ? _a : []) {
        // Read query from cache
        const data = cache.readQuery({
            query,
            variables,
        });
        if (!data)
            continue;
        // Remove deleted item from the cache copy
        const result = Object.assign({}, data, {
            [fieldName]: Object.assign(Object.assign({}, data[fieldName]), { items: [
                    ...data[fieldName].items.filter((item) => item.id !== deletedId),
                ] }),
        });
        //Overwrite the cache with the new results
        cache.writeQuery({
            query,
            data: result,
            variables,
        });
    }
};
const cacheUpdaterUpdate = ({ context }) => (cache, { data }) => {
    var _a;
    if (!data || !data[context.fieldName]) {
        return undefined;
    }
    const newEntity = data[context.fieldName];
    const updatedId = context.variables.id ||
        (context.variables.input && context.variables.input.id);
    for (const { query, variables, fieldName } of (_a = context.queries) !== null && _a !== void 0 ? _a : []) {
        // Read query from cache
        const data = cache.readQuery({
            query,
            variables,
        });
        if (!data)
            continue;
        // Replace updated item in the cache copy
        const result = Object.assign({}, data, {
            [fieldName]: Object.assign(Object.assign({}, data[fieldName]), { items: [
                    ...data[fieldName].items.filter((item) => item.id !== updatedId),
                    newEntity,
                ] }),
        });
        //Overwrite the cache with the new results
        cache.writeQuery({
            query,
            data: result,
            variables,
        });
    }
};
export const updateFunctionCreators = {
    add: cacheUpdaterAdd,
    update: cacheUpdaterUpdate,
    remove: cacheUpdaterRemove,
    delete: cacheUpdaterRemove,
};
export const makeUpdateFunction = (operationName, context) => {
    const operationType = (operationName
        .toLowerCase()
        .match(/(add|update|remove|delete)/i) || [null])[0];
    if (!operationType) {
        console.error('unknown operation type', operationName);
        throw new Error(`unknown operation type: ${operationName}`);
    }
    return updateFunctionCreators[operationType]({ context });
};
